import { Extensions, JSONContent } from '@tiptap/core';
import { generateJSON } from '@tiptap/html';

export const htmlToTiptapJson = ({
  extensions,
  html,
}: {
  extensions: Extensions;
  html: string;
}): JSONContent => {
  return generateJSON(html, extensions) as JSONContent;
};
